export const m0l4Solution = `%lang starknet
// do not modify code on this line or above

// TODO: Create a struct here so the test passes
struct Currency {
    name : felt,
    decimals : felt,
}

// do not modify code on this line or below

@external
func test_currency_sum{syscall_ptr : felt*}() {
    alloc_locals;
    local euro : Currency = Currency('Euro', 2);
    assert euro.name = 'Euro';
    return ();
}`;
